@if (isAuthenticated$ | async) {
	<app-infobox></app-infobox>
	<app-question-dialog></app-question-dialog>
	<app-focustip></app-focustip>
	<app-loader></app-loader>

	@let backgroundColor = selectedTheme().backgroundColor;
	@let color = selectedTheme().color;
	@if (!hideTopBarAndNavForPilotFile()) {
		<nav class="example-container">
			<mat-toolbar
				[style.backgroundColor]="backgroundColor"
				[style.color]="color"
				class="example-toolbar z-2 d-flex justify-content-between align-items-center"
				style="box-shadow: 0 4px 6px -4px #03438b3d"
			>
				<div class="d-flex justify-content-between align-items-center">
					<button
						class="d-flex justify-content-center align-content-center me-2"
						mat-icon-button
						(click)="snav.toggle()"
					>
						<i class="fa-solid fa-bars"></i>
					</button>
					<img class="px-2 d-none d-md-block" src="assets/logo.webp" alt="OSKAR" height="40" width="145" />
					<h1 class="px-2 d-none d-md-block">
						@if (bridge.titleLink()) {
							<a
								class="navbar-title-link"
								[routerLink]="bridge.titleLink()"
								[innerHTML]="bridge.title()"
							></a>
						} @else {
							<div [innerHTML]="bridge.title()"></div>
						}
					</h1>

					@switch (bridge.saveStatus()) {
						@case ('saving') {
							<span class="px-2"><i class="fas fa-cloud fa-spin"></i></span>
						}
						@case ('saved') {
							<span class="px-2"><i class="fas fa-cloud"></i></span>
						}
					}
				</div>

				<div class="d-flex justify-content-between align-items-center overflow-auto">
					@if (bridge.showReservationSearch()) {
						<app-reservation-search class="search"></app-reservation-search>
					}
					@if (bridge.content()) {
						<ng-container [ngTemplateOutlet]="bridge.content()"></ng-container>
					}

					<button mat-icon-button [matMenuTriggerFor]="menu" class="mx-2">
						<app-theme-chip-split
							[backgroundColor]="backgroundColor"
							[color]="color"
						></app-theme-chip-split>
					</button>

					<mat-menu #menu="matMenu">
						@for (theme of NAVBAR_THEMES; track $index) {
							<button (click)="changeTheme(theme)" mat-menu-item>
								<div class="d-flex justify-content-center align-items-center">
									<app-theme-chip-split
										[backgroundColor]="theme.backgroundColor"
										[color]="theme.color"
									></app-theme-chip-split>
								</div>
							</button>
						}
					</mat-menu>
				</div>
			</mat-toolbar>

			<mat-sidenav-container class="example-sidenav-container" hasBackdrop="true" [style.marginTop.px]="0">
				<mat-sidenav [style.backgroundColor]="backgroundColor" #snav [mode]="'side'" fixedTopGap="56">
					<mat-nav-list>
						<ng-container
							[ngTemplateOutlet]="renderNodes"
							[ngTemplateOutletContext]="{ $implicit: MENU_ITEMS() }"
						>
						</ng-container>
					</mat-nav-list>

					<ng-template #renderNodes let-nodes>
						@for (item of nodes; track item.name) {
							@if (item.permissions) {
								@if (item.children?.length) {
									<mat-list-item
										class="parent cursor-pointer"
										role="button"
										(click)="toggle(item, $event)"
									>
										<div
											[style.color]="color"
											class="w-100 d-flex justify-content-between align-items-center"
										>
											<span><i [class]="item.iconName" class="me-2"></i> {{ item.name }}</span>
											<i
												class="fa-solid fa-angle-down menu-button ms-2"
												[ngClass]="{ rotated: item.showSubmenu }"
											></i>
										</div>
									</mat-list-item>

									<div class="submenu" [class.expanded]="item.showSubmenu">
										<div [style.color]="'#03438b'" class="content">
											<ng-container
												[ngTemplateOutlet]="renderNodes"
												[ngTemplateOutletContext]="{ $implicit: item.children }"
											>
											</ng-container>
										</div>
									</div>
								} @else {
									<a mat-list-item class="cursor-pointer" [routerLink]="item.routerLink">
										<div
											[style.color]="color"
											class="w-100 d-flex justify-content-between align-items-center"
										>
											<span><i [class]="item.iconName" class="me-2"></i> {{ item.name }}</span>
										</div>
									</a>
								}
							}
						}
					</ng-template>
				</mat-sidenav>
				<mat-sidenav-content> <router-outlet /> </mat-sidenav-content>
			</mat-sidenav-container>
		</nav>
	} @else {
		<router-outlet />
	}
} @else {
	<router-outlet class="container-fluid"></router-outlet>
}
